import { useMemo } from 'react'
import { useParams } from 'next/navigation'
import type { TypeLang } from '@/schema'
import countriesData from '@/data/countries.json'

type TypeCountryItem = {
  name: Record<string, string>
  code: string
  defaultLanguage?: string
}

export type TypeCountryOption = {
  name: string
  value: string
  code: string
  defaultLanguage?: string
}

export function useCountries(): TypeCountryOption[] {
  const { lang }: { lang: TypeLang } = useParams()

  return useMemo(() => {
    const raw: TypeCountryItem[] = countriesData?.data ?? []
    return raw.map(item => {
      const fallbackLang = item.defaultLanguage ?? 'en'
      return {
        ...item,
        name: item.name[lang] ?? item.name[fallbackLang],
        value: item.code
      }
    })
  }, [lang])
}
